<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.168 1.66675H5.83464C4.91416 1.66675 4.16797 2.41294 4.16797 3.33341V16.6667C4.16797 17.5872 4.91416 18.3334 5.83464 18.3334H14.168C15.0884 18.3334 15.8346 17.5872 15.8346 16.6667V3.33341C15.8346 2.41294 15.0884 1.66675 14.168 1.66675Z" stroke="#082964" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 15H10.0083" stroke="#082964" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
